<template>
  <div class="container interaction-wrapper">
    <div class="row pt-3" v-show="showLink">
      <div class="col-12" style="text-align: center;">
        <a @click="onEditing">Enter {{type}} Interaction Here</a>
      </div>
    </div>
    <div class="row" v-if="entityId !== null">
      <div class="col-12">
        <h4>{{type}} Interaction</h4>
        <h5 title="Open Employer in New Tab" class="sub-head" @click="openNewTab" style="cursor: pointer">
          {{newEntityName}}
          <i class="fa fa-external-link" v-if="onChange" />
        </h5>
      </div>
      <amf-textarea
        class="interaction-input"
        :columns="3"
        label="Please enter interaction here..."
        v-model="note"
        :validator="$v.note"
        :autofocus="true"
      ></amf-textarea>
      <amf-datepicker
        class="interaction-input"
        :columns="3"
        label="Contacted On"
        style="color: black;"
        v-model="contactedOn"
        :validator="$v.contactedOn"
        :disabled="disableContactedOn"
      ></amf-datepicker>
      <amf-select
        class="interaction-input"
        :columns="3"
        label="Interaction Type"
        caption="--Interaction Type--"
        :options="interactionTypes"
        v-model="interactionType"
        :validator="$v.interactionType"
      ></amf-select>
      <amf-select
        class="interaction-input"
        :columns="3"
        label="Caller Type"
        caption="--Caller Type--"
        :options="callerTypes"
        v-model="callerType"
        :validator="$v.callerType"
        v-show="ifCallerTypeRequire"
      ></amf-select>
      <amf-search-box
        :search="search"
        label="Caller Name"
        v-model="callerName"
        :columns="3"
        :isAutocomplete="true"
        placehold=""
        :validator="$v.callerName"
        v-show="ifCallerTypeRequire && searchList" />
      <amf-input
        class="interaction-input"
        :columns="3"
        label="Caller Name"
        v-model="callerName"
        :validator="$v.callerName"
        v-show="ifCallerTypeRequire && !searchList"
      ></amf-input>
      <div class="col-12 form-group" :class="{ 'invalid': isInvalid }" style="margin-top: 1.3rem;">
        <label class="amf-input-label">Reasons</label>
        <multiselect
          class="multiselect"
          style="line-height: 1;"
          v-model="value"
          track-by="name"
          placeholder="Start typing to search ..."
          label="name"
          :options="allTags"
          :multiple="true"
          :hideSelected="true"
          @close="onTouch"
        ></multiselect>
        <label class="typo__label form__label" v-show="isInvalid">Must have at least one value</label>
      </div>
      <div class="col-12 form-group">
        <amf-file-upload label="Upload Files" :multiple="true" @change="onSelectFiles" />
      </div>
      <div v-if="!onChange" class="col-12 form-group">
        <amf-button class="btn-default pull-right ml-2" :onClick="reset">Cancel</amf-button>
        <amf-button class="btn-success pull-right" :onClick="save">Save</amf-button>
      </div>
      <div v-else class="col-12 form-group">
        <amf-button class="btn-default pull-right ml-2" :onClick="reset">Cancel</amf-button>
        <amf-button class="btn-success pull-right" :onClick="saveAndSwitch">Save</amf-button>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

function initialValue() {
  return {
    isTouched: false,
    value: [],
    options: [],
    contactedOn: Date.now(),
    note: null,
    error: [],
    callerName: null,
    showEditorForInteral: false,
    entityId: null,
  };
}
export default {
  data() {
    return {
      interactionTypes: [
        { id: "Phone", name: "Phone" },
        { id: "Chat", name: "Chat" },
        { id: "Email", name: "Email" }
      ],
      callerTypes: [
        { id: "PA", name: "PA" },
        { id: "Participant", name: "Participant" },
        { id: "Dependent", name: "Dependent" },
        { id: "Broker", name: "Broker" },
        { id: "Third Party", name: "Third Party" },
        { id: "Internal", name: "Internal" }
      ],
      isTouched: false,
      value: [],
      allTags: [],
      options: [],
      contactedOn: Date.now(),
      note: null,
      interactionType: localStorage.getItem("CONTACT_METHOD"),
      callerType: localStorage.getItem("CALLER_TYPE"),
      error: [],
      entityId: null,
      currentEmployerName: null,
      callerName: null,
      amfOptions: { noTracking: true, },
      files: null,
      fileError: null
    };
  },
  components: {
    Multiselect
  },
  props: {
    type: String,
    employerId: String,
    participantId: String
  },
  created: async function() {
    await this.load();
  },
  methods: {
    async load() {
      const tagEntityType = this.type === 'Employee' ? 'Participant' : this.type;
      this.allTags = await romeApi.get(`/config/changelogtags?entityType=${tagEntityType}&systemOnly=false`);
    },
    onEditing() {
      if (this.type === "Employee") {
        this.entityId = this.participantId;
        this.currentEmployerName = this.name;
        this.callerName = this.firstName && this.lastName ? `${this.firstName} ${this.lastName}` : null;
      } else {
        this.entityId = this.employerId;
      }
    },
    async save() {
      this.onTouch();
      if (this.$v.$invalid) {
        return false;
      }

      const formData = new FormData();

      formData.append('description', this.note);
      formData.append('submittedTags', this.value.map(a => a.id));
      formData.append('contactedOn',  moment(this.contactedOn).format("YYYY-MM-DD"));
      formData.append('interactionType', this.interactionType);
      formData.append('entityGuid', this.entityId);      

      if (this.interactionType !== "None") {
        formData.append('contactType', this.callerType);
        let formattedCallerName = this.callerName ? this.callerName.trim() : this.callerName;
        formData.append('contactName', formattedCallerName);
      }

      if (this.files && this.files.length) {
        for (var i = 0; i < this.files.length; i++) {
          formData.append(`file${i}`, this.files[i]);
        }
      }

      await romeApi.upload(        
        `interaction/${this.interactionType}`,
        formData
      );
      this.saveSetting();
      this.reset();
      this.$parent.$emit('closePanel');
    },
    async saveAndSwitch() {
      var res = await this.save();
      if (res) this.onEditing();
    },
    reset() {
      Object.assign(this.$data, initialValue());
      this.$v.$reset();
      this.files = null;
      this.isTouched = false;
    },
    onTouch() {
      this.$v.$touch();
      this.isTouched = true;
    },
    saveSetting() {
      localStorage.setItem("CALLER_TYPE", this.callerType);
      localStorage.setItem("CONTACT_METHOD", this.interactionType);
    },
    openNewTab() {
      let routeData = this.$router.resolve({
        path: this.newEntityPath
      });
      window.open(routeData.href, "_blank");
    },
    async search(searchVal) {
      let list = this.searchList.filter(x => x.name.includes(searchVal.toLowerCase()));
      // console.log("Interaction search list: ", searchVal.toLowerCase(), list);
      return _.take(list, 10);
    },
    onSelectFiles(files) {
      this.files = files;
    },
  },

  computed: {
    ...amfx.map("contacts", "contacts"),
    ...amfx.map("oprs", "oprs"),
    ...amfx.map("employer/broker", "brokerId,xFirstName,xLastName"),
    ...amfx.map("participant", "firstName, lastName, fullName"),
    ...amfx.map("employer", "name"),
    ...amfx.map("session", "isMsr"),
    searchList() {
      let list = null;

      if(this.callerType == 'PA') {
        list = this.contactsFiltered;
      }
      else if(this.callerType == 'Third Party') {
        list = this.oprsFiltered;
      }
      else if(this.callerType == 'Broker') {
        list = this.brokersFiltered;
      }

      return this.type == 'Employer' ? list : null;
    },
    contactsFiltered() {
      return this.contacts.map(x => { return {
        icon: "fa-user",
        title: x.firstName + ' ' + x.lastName,
        name: (x.firstName + ' ' + x.lastName).toLowerCase(),
        id: x.employerContactId,
      }});
    },
    oprsFiltered() {
      return this.oprs
        .filter(x => x.oprFirstName)
        .map(x => { return {
          icon: "fa-user",
          title: x.oprFirstName + ' ' + x.oprLastName,
          name: (x.oprFirstName + ' ' + x.oprLastName).toLowerCase(),
          id: x.oprId,
        }});
    },
    brokersFiltered() {
      if(this.brokerId) {
        return [{
          icon: "fa-user",
          title: this.xFirstName + ' ' + this.xLastName,
          name: (this.xFirstName + ' ' + this.xLastName).toLowerCase(),
          id: this.brokerId,
        }]
      }
      else {
        return [];
      }
    },
    showLink() {
      switch (this.type) {
        case "Employee":
          if (this.participantId !== null && this.entityId === null) {
            return true;
          } else {
            return false;
          }
        case "Employer":
          if (this.employerId !== null && this.entityId === null) {
            return true;
          } else {
            return false;
          }
        default:
          return false;
      }
    },
    ifCallerTypeRequire() {
      return this.interactionType !== "None";
    },
    callerNameValidation() {
      return this.ifCallerTypeRequire && this.callerType !== "Participant";
    },
    isInvalid() {
      return this.isTouched && this.value.length === 0;
    },
    disableContactedOn() {
      if (this.isMsr && this.type == "Employee") {
        return true;
      }
      return false;
    },
    onChange() {
     if(this.entityId!=this.participantId &&(this.participantId || (this.currentEmployerName != this.name)))
     {
       return true;
     }
      return false;
    },
    newEntityName() {
      return !this.participantId ? this.name : this.fullName;
    },
    newEntityPath() {
      return !this.participantId
        ? `/employer/${this.employerId}/general`
        : `/participant/${this.participantId}/general`;
    }
  },
  validations() {
    return {
      contactedOn: v.build(
        v.required(),
        v.custom(
          a => !a || moment(a).isSameOrBefore(moment()),
          "Effective date cannot be in the future"
        )
      ),
      note: v.build(v.required()),
      interactionType: v.build(v.required()),
      callerType: v.build(v.requiredIf("ifCallerTypeRequire")),
      callerName: v.build(v.requiredIf("callerNameValidation")),
      value: v.build(v.required())
    };
  }
};
</script>

<style lang="scss" scoped>
.typo__label {
  color: #f00;
}

.interaction-wrapper {
  h4 {
    color: #1a1a3e;
  }

  h5 {
    color: #232353;
  }

  a {
    text-decoration: underline;
  }

  a:hover {
    cursor: pointer;
  }

  input.multiselect__input:focus {
    box-shadow: none !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/interactions/Interaction.vue